import { render, staticRenderFns } from "./CheckupView.vue?vue&type=template&id=0d8aa7fe"
import script from "./CheckupView.vue?vue&type=script&lang=ts"
export * from "./CheckupView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports